import { useQuery, gql } from '@apollo/client';

export const GET_PLATFORM_COMPANY_BUSINESS_ADDRESSES = gql`
  query getPlatformCompanyBusinessAddresses {
    getPlatformCompanyBusinessAddresses {
      _id
      companyId
      companyLocationId
      zipCode
      street
      city
      country
    }
  }
`;

export const useGetPlatformCompanyBusinessAddresses = () => {
  const { data, loading } = useQuery(GET_PLATFORM_COMPANY_BUSINESS_ADDRESSES, {
    fetchPolicy: 'network-only',
  });

  return {
    companyBusinessAddresses: data?.getPlatformCompanyBusinessAddresses || [],
    loading,
  };
};
